/* eslint-disable no-undef */

import React, { PureComponent } from 'react'
import Question from '../components/Question'
import { withStyles } from '@material-ui/core/styles/index'
import QuestionPageFooter from './partials/QuestionPageFooter'
import AttentionElement from '../components/AttentionElement'
import { styles } from './Prelander.styles'
import QuestionPageHeader from './partials/QuestionPageHeader'
import QuestionPageStepper from './partials/QuestionPageStepper'
import PrelanderComplete from '../components/PrelanderComplete'
import { Box, Button, Grid, Typography } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import HeaderImage from './partials/HeaderImage'
import Terms from './partials/Terms'
import queryString from 'query-string'
import { storePrelanderAnswer } from '../../api'
import parse from 'html-react-parser'

const completeAnimationStepLenghts = [4000, 4000, 5000, 2000, 2000, 5000]
const parsedQueryString = queryString.parse(window.location.search)
const defaultAnswers = parsedQueryString['pa'] ? [parsedQueryString['pa']] : []

class Prelander extends PureComponent {
    state = {
        questionPages: [],
        questionPageIndex: null,
        questionValues: [],
        showComplete: false,
        completeAnimationStep: 0,
        answers: defaultAnswers
    }

    componentDidMount() {
        const questionPages = this.props.prelander.questionPages
        const questionPageIndex = questionPages[0] ? 0 : null
        if (questionPageIndex === null) {
            this.showComplete()
        }
        this.props.onAnswersChanged(defaultAnswers)
        this.setState({ questionPages: questionPages, questionPageIndex: questionPageIndex })
    }

    onQuestionValueChanged = (title, value, validate = true) => {
        console.log('answer', title, value)
        const nextQuestionPageIndex = this.state.questionPageIndex + 1
        const questionPageIndex = this.state.questionPages[nextQuestionPageIndex] ? nextQuestionPageIndex : null
        if (questionPageIndex === null) {
            this.showComplete()
        }
        const newAnswers = [...this.state.answers, value]
        this.props.onAnswersChanged(newAnswers)
        this.setState({ questionPageIndex: questionPageIndex, answers: [...this.state.answers, value] })

        storePrelanderAnswer(this.props.visitorSessionId, title, value)
    }

    showComplete = () => {
        this.setState({ showComplete: true })

        if (this.props.prelander.completeAnimation === 'long') {
            let waitTime = completeAnimationStepLenghts[0]
            setTimeout(() => {
                this.setState({ completeAnimationStep: 1 })
            }, waitTime)

            waitTime += completeAnimationStepLenghts[1]
            setTimeout(() => {
                this.setState({ completeAnimationStep: 2 })
            }, waitTime)

            waitTime += completeAnimationStepLenghts[2]
            setTimeout(() => {
                this.setState({ completeAnimationStep: 3 })
            }, waitTime)

            waitTime += completeAnimationStepLenghts[3]
            setTimeout(() => {
                this.setState({ completeAnimationStep: 4 })
            }, waitTime)

            waitTime += completeAnimationStepLenghts[4]
            setTimeout(() => {
                this.setState({ completeAnimationStep: 5 })
            }, waitTime)

            waitTime += completeAnimationStepLenghts[5]
            setTimeout(() => {
                this.props.onComplete()
            }, waitTime)
        } else {
            let waitTime = completeAnimationStepLenghts[0]
            setTimeout(() => {
                this.setState({ completeAnimationStep: 1 })
            }, waitTime)

            waitTime += completeAnimationStepLenghts[1]
            setTimeout(() => {
                this.setState({ completeAnimationStep: 2 })
            }, waitTime)

            waitTime += completeAnimationStepLenghts[2]
            setTimeout(() => {
                this.props.onComplete()
            }, waitTime)
        }
    }

    render() {
        const { answers } = this.state
        const { classes, prelander, theme, layout } = this.props

        const questionValues = this.state.questionValues
        const questionPage = this.state.questionPages[this.state.questionPageIndex]
        const completeStep = this.state.completeAnimationStep
        const headerImagePositionInCard = !(layout === 'exclusive' || layout === 'premium-exclusive')

        return (
            <Box className={'prelander-wrapper'}>
                {headerImagePositionInCard && theme?.headerImage && <HeaderImage theme={theme} questionPage={questionPage} />}
                {answers && answers.length > 0 && (
                    <Box className={classes.prelanderAnswerWrapper + ' prelanderAnswerWrapper'}>
                        {answers.map((answer, index) => (
                            <Box className={classes.prelanderAnswer} key={index}>
                                {answer}
                            </Box>
                        ))}
                    </Box>
                )}
                {!this.state.showComplete && questionPage && (
                    <>
                        {questionPage.showHeader && <QuestionPageHeader questionPage={questionPage} />}
                        <Box mt={{ xs: -1, sm: -2 }} display={'flex'}></Box>
                        <Grid container spacing={2} classes={{ item: classes.questionContainer }} className={classes.questionWrapper} item={true}>
                            {questionPage.elements.map((element, key) => {
                                const questionValue = questionValues.find(x => x.id === element.id)
                                const value = questionValue ? questionValue.value : null

                                const questionElement = element
                                questionElement.id = questionElement.title

                                return (
                                    <React.Fragment key={key}>
                                        {element.elementType === 'question' && (
                                            <Question
                                                question={questionElement}
                                                value={value}
                                                className={classes.prelanderQuestion}
                                                onValueChanged={this.onQuestionValueChanged}
                                            />
                                        )}
                                        {element.elementType === 'attentionElement' && <AttentionElement element={element} />}
                                    </React.Fragment>
                                )
                            })}
                            {questionPage.submitButton.show && (
                                <Grid item xs={12} sm={12} className={classes.buttons} key={'button'}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        className={classes.button}
                                        onClick={this.onSubmit}
                                        disabled={isLoading}
                                    >
                                        {alias === 'yhteystietosivu1' ? 'Jatka' : questionPage.submitButton.label}
                                        {!isLoading && (
                                            <FontAwesomeIcon className={classes.rightIcon} size="lg" icon={['far', questionPage.submitButton.icon]} />
                                        )}
                                        {isLoading && (
                                            <FontAwesomeIcon className={classes.rightIcon} size="lg" icon={['far', 'spinner-third']} spin />
                                        )}
                                    </Button>
                                </Grid>
                            )}
                            {questionPage.stepper && questionPage.stepper.place === 'footer' && (
                                <Grid item xs={12} sm={12} key={'stepper'} style={{ marginTop: 32, marginBottom: -16 }}>
                                    <QuestionPageStepper stepper={questionPage.stepper} />
                                </Grid>
                            )}
                            {questionPage.image && (
                                <div className={classes.imageWrapper}>
                                    <img src={questionPage.image} className={classes.image} />
                                </div>
                            )}
                        </Grid>
                        <Box py={1.5}></Box>
                        {questionPage.footerText && (
                            <div className={'question-page-footer-text-wrapper ' + classes.questionPageFooterTextWrapper}>
                                <Typography component="div" variant="body1" align="center" color="textSecondary" id={'question-page-footer-text'}>
                                    {parse(questionPage.footerText)}
                                </Typography>
                            </div>
                        )}
                        {questionPage.showFooter && <QuestionPageFooter />}
                        {questionPage && questionPage.termsPosition === 'footer' ? (
                            <Terms domain={questionPage.domain} theme={theme} layout={layout} />
                        ) : (
                            <Box mt={{ xs: 1, sm: 3 }} />
                        )}
                    </>
                )}
                {this.state.showComplete && (
                    <>
                        <PrelanderComplete
                            step={completeStep}
                            prelander={prelander}
                            animationLenght={completeAnimationStepLenghts[completeStep]}
                            questionPage={this.props.prelander.questionPages[0]}
                            theme={theme}
                            layout={layout}
                        />
                    </>
                )}
            </Box>
        )
    }
}

export default withStyles(styles)(Prelander)
